export class NetworkDescriptionAndDiagram {
    networkDescription: string;
    //networkDiagram: string; // file
    networkDiagram: string;
}